import { Component, inject, input } from '@angular/core';
import { PlausibleDirective } from '@agilox/directive/plausible';
import { TranslatePipe } from '@ngx-translate/core';
import * as htmlToImage from 'html-to-image';
import { FileService } from '@agilox/common';
import { ButtonComponent } from '@agilox/ui';

@Component({
	selector: 'summary-download-page',
	templateUrl: './summary-download-page.component.html',
	imports: [TranslatePipe, ButtonComponent, PlausibleDirective],
})
export class SummaryDownloadPageComponent {
	private readonly fileService = inject(FileService);

	overviewPageId = input('');
	overviewLabelId = input('');
	year = input<number>();

	downloadPNG(): void {
		const node = document.getElementById(this.overviewPageId());
		if (!node) return;

		node.classList.remove('-translate-x-full', 'transition-all', 'duration-1000');

		const year = document.getElementById(this.overviewLabelId());
		if (!year) return;
		year.classList.remove('hidden');

		htmlToImage
			.toPng(node, {
				quality: 1,
				backgroundColor: '#fff',
			})
			.then((dataUrl) => {
				this.fileService.downloadBase64ToPng('summary-of-the-year.png', dataUrl);
				node.classList.add('-translate-x-full', 'transition-all', 'duration-1000');
				year.classList.add('hidden');
			});
	}
}
